import React, { useEffect, useState } from "react";
import HomeBanner from "./components/HomeBanner";
import AdvancedSearch from "./components/AdvancedSearch";
import PremiumRegistrations from "./components/PremiumRegistrations";
import ViewNumber from "./components/ViewNumber";
import { apiRequest } from "../../utils/api";
import { useNavigate } from "react-router-dom";
import Seller from "./components/Seller";
import Loader from "./components/Loader";
import Toast, { errorToast } from "../../utils/Toast";
import { extractNumber } from "../../utils/function";
import usePageTitleAndMeta from "../../hooks/usePageTitleAndMeta";
import { addData, getData } from "../../utils/storage";
import FeaturedRegistrations from "./components/FeaturedRegistrations";
import { useLayoutEffect } from "react";
import {
  generateNewStyleNumber,
  prefixStyleNumber,
  getAlphas,
} from "../../utils/searchNumbers";

function Home() {
  const [newStyles, setNewStyles] = useState([]);
  const [oldStyles, setOldStyles] = useState([]);
  const [getPrefixStyles, setGetPrefixStyles] = useState([]);
  const [suffix, setSuffix] = useState([]);
  const [allNumbers, setAllNumbers] = useState([]);
  const [oldAll, setOldAll] = useState([]);
  const [newAll, setNewAll] = useState([]);
  const [ppAll, setPpAll] = useState([]);
  const [preAll, setPreAll] = useState([]);
  const [sfAll, setSfAll] = useState([]);
  const [premiums, setPremiums] = useState([]);
  const [openSales, setOpenSales] = useState([]);
  const [openSaleAll, setOpenSaleAll] = useState([]);
  const [plate, setPlate] = useState("");
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [allArray, setAllArray] = useState([]);
  const [searchNumber, setSearchNumber] = useState([]);
  const [dynamicBanner, setDynamicBanner] = useState("");
  const [dynamicStyles, setDynamicStyles] = useState({});
  const [dynamicImage, setDynamicImage] = useState("");
  const [dynamicImageStatus, setDynamicImageStatus] = useState("");

  async function getDynamicImage() {
    try {
      let res = await apiRequest.get(`/dynamic-image/single/1`);
      if (res.data.status == 200) {
        setDynamicImage(res.data.message?.url);
        setDynamicImageStatus(res.data.message?.status);
      }
    } catch (error) {}
  }
  async function getDynamicBanner(area = "banner") {
    try {
      let res = await apiRequest.get(`/dynamic-text/texts/${area}`);
      if (res.data.status == 200) {
        setDynamicBanner(res.data.message[0]);
        setDynamicStyles(JSON.parse(res.data.message[0]?.styles));
      }
    } catch (error) {}
  }

  useEffect(() => {
    getDynamicBanner("banner");
    getDynamicImage();
  }, []);

  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setIsPrefixSearch(false);
    setIsNewSearch(false);
    if (!plate) {
      setNewStyles([]);
      setOldStyles([]);
      setGetPrefixStyles([]);
      setPremiums([]);
      return errorToast("Please Enter Number");
    }
    setIsLoading(true);
    try {
      await getNewStyles(plate);
      await getOldStyles(plate);
      await getAllPrefixStyles(plate);
      await getPremiums(plate);
      await getSuffix(plate);
      await getOpenSales(plate);

      window.scrollTo(0, 750);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  async function getPremiums(plate) {
    addData("search-plate", plate);
    let res = await apiRequest.get(`/premium/search/${plate}/1`);
    if (res.data.status === 200) {
      let result = res.data.message;

      let valid = result.filter((p) => p.sell_number_status === "APPROVED");

      let all = valid.map((r) => ({
        fullNumber: r.sell_number,
        price: r.admin_price,
        route: "view-premium",
      }));

      setPreAll(all);
      // setSearchNumber(
      //   searchNumber.length > 0
      //     ? searchNumber
      //     : [
      //         {
      //           fullNumber: number?.sell_number,
      //           price: number?.admin_price,
      //           route: "view-premium",
      //         },
      //       ]
      // );
      setPremiums(
        result
          .filter((p) => p.sell_number_status === "APPROVED")
          .map((r) => ({
            fullNumber: r.sell_number,
            price: r.admin_price,
          }))
      );
    } else {
      setNewStyles([]);
      console.log(res.data.message);
    }
  }
  async function getSuffix(plate) {
    addData("search-plate", plate);
    let res = await apiRequest.get(`/premium/search-suffix/${plate}/1`);
    if (res.data.status === 200) {
      let result = res.data.message;

      let valid = result.filter((p) => p.sell_number_status === "APPROVED");

      let all = valid.map((r) => ({
        fullNumber: r.sell_number,
        price: r.admin_price,
        route: "view-premium",
      }));

      setSfAll(all);
      // setSearchNumber(
      //   searchNumber.length > 0
      //     ? searchNumber
      //     : [
      //         {
      //           fullNumber: number?.sell_number,
      //           price: number?.admin_price,
      //           route: "view-premium",
      //         },
      //       ]
      // );
      setSuffix(
        result
          .filter((p) => p.sell_number_status === "APPROVED")
          .map((r) => ({
            fullNumber: r.sell_number,
            price: r.admin_price,
          }))
      );
    } else {
      setSuffix([]);
      console.log(res.data.message);
    }
  }
  async function getOpenSales(plate) {
    try {
      let res = await apiRequest.get(`/open-sale/search/${plate}/1`);
      if (res.data.status === 200) {
        const result = res.data.message;
        setOpenSales(
          result.map((r) => ({
            fullNumber: r.fullNumber?.replace(
              extractNumber(r.fullNumber),
              `${extractNumber(r.fullNumber)} `
            ),
            price: r.price,
          }))
        );
        setOpenSaleAll(
          result.map((r) => ({
            fullNumber: r.fullNumber,
            price: r.price,
            route: "view-open-sale",
          }))
        );
      } else {
        setOpenSales([]);
      }
    } catch (error) {
      setOpenSales([]);
      console.log(error);
    }
  }
  async function getNewStyles(plate) {
    let res = await apiRequest.get(`/plate/new-style/search/${plate}/${page}`);
    if (res.data.status === 200) {
      let { message } = res.data;

      let value = message.map((p) => ({
        price: p.price,
        fullNumber: p.fullNumber?.replace(
          extractNumber(p.fullNumber),
          `${extractNumber(p.fullNumber)} `
        ),
      }));

      let valueSet = new Set(value);

      setNewStyles([...valueSet]);

      let all = res.data.message?.map((p) => ({
        price: p.price,
        fullNumber: p.fullNumber,
        route: "view",
      }));

      setNewAll(all);
      // let number = res.data?.message?.filter((p) => {
      //   console.log(p?.fullNumber?.replace(/\s+/g, "").toLowerCase());
      //   return (
      //     p?.fullNumber?.replace(/\s+/g, "").toLowerCase() ==
      //     plate.replace(/\s+/g, "").toLowerCase()
      //   );
      // })[0];
      // setSearchNumber(
      //   searchNumber.length > 0
      //     ? searchNumber
      //     : [
      //         {
      //           price: number.price,
      //           fullNumber: number.fullNumber,
      //           route: "view",
      //         },
      //       ]
      // );
    } else {
      setNewStyles([]);
      console.log(res.data.message);
    }
  }
  async function getOldStyles(plate) {
    let res = await apiRequest.get(`/old/date-less/search/${plate}/${page}`);
    if (res.data.status === 200) {
      let result = res.data.message;

      // setSearchNumber(
      //   result.filter(
      //     (p) =>
      //       p?.old_fullNumber?.toLowerCase() ===
      //       plate.replace(/\s+/g, "").toLowerCase()
      //   )
      // );

      setOldStyles(
        result.map((r) => ({
          fullNumber: r.old_fullNumber?.replace(
            extractNumber(r.old_fullNumber),
            ` ${extractNumber(r.old_fullNumber)}`
          ),
          price: r.old_price,
        }))
      );

      let all = result.map((r) => ({
        fullNumber: r.old_fullNumber,
        price: r.old_price,
        route: "view-old",
      }));

      setOldAll(all);

      // let number = res.data?.message?.filter(
      //   (p) => p?.old_fullNumber?.toLowerCase() === plate.toLowerCase()
      // )[0];
      // setSearchNumber(
      //   searchNumber.length > 0
      //     ? searchNumber
      //     : [{ ...number, route: "view-old" }]
      // );
    } else {
      setNewStyles([]);
      console.log(res.data.message);
    }
  }
  async function getAllPrefixStyles(plate) {
    let res = await apiRequest.get(
      `/prefix/prefix-style/search/${plate}/${page}`
    );
    if (res.data.status === 200) {
      let result = res.data.message;

      setGetPrefixStyles(
        result.map((r) => ({
          fullNumber: r.pp_fullNumber?.replace(
            extractNumber(r.pp_fullNumber),
            `${extractNumber(r.pp_fullNumber)} `
          ),
          price: r.pp_price,
        }))
      );

      let all = result.map((r) => ({
        fullNumber: r.pp_fullNumber,
        price: r.pp_price,
        route: "view-prefix",
      }));

      setPpAll(all);
      // let number = res.data?.message?.filter(
      //   (p) =>
      //     p?.pp_fullNumber?.replace(/\s+/g, "").toLowerCase() ===
      //     plate.replace(/\s+/g, "").toLowerCase()
      // )[0];

      // setSearchNumber(
      //   searchNumber.length > 0
      //     ? searchNumber
      //     : [{ ...number, route: "view-prefix" }]
      // );
    } else {
      setNewStyles([]);
      console.log(res.data.message);
    }
  }
  usePageTitleAndMeta("JDM Plates", "JDM Plates", "JDM Plates");

  useEffect(() => {
    localStorage.removeItem("uuid");
    localStorage.removeItem("cart-plate");
    localStorage.removeItem("plate-info");
    if (isLoading) document.title = "Searching.....";
    else document.title = "JDM Plates";
  }, [isLoading]);

  useLayoutEffect(() => {
    // Build a set of all fullNumbers already covered by core plate sections
    const coreNumbers = new Set(
      [...newAll, ...ppAll, ...oldAll].map((r) =>
        r.fullNumber?.replace(/\s+/g, "").toLowerCase()
      )
    );

    // Filter openSaleAll to remove any plate already shown in core sections
    const dedupedOpenSaleAll = openSaleAll.filter(
      (r) => !coreNumbers.has(r.fullNumber?.replace(/\s+/g, "").toLowerCase())
    );

    // Also update the display state for open sale section (with new-style spacing)
    setOpenSales(
      dedupedOpenSaleAll.map((r) => ({
        fullNumber: r.fullNumber?.replace(
          extractNumber(r.fullNumber),
          `${extractNumber(r.fullNumber)} `
        ),
        price: r.price,
      }))
    );

    let allArr = [...newAll, ...oldAll, ...ppAll, ...preAll, ...sfAll, ...dedupedOpenSaleAll];
    setAllArray(allArr);
    setSearchNumber(
      allArr.filter(
        (r) =>
          r.fullNumber?.replace(/\s+/g, "").toLowerCase() ===
          plate?.replace(/\s+/g, "").toLowerCase()
      )
    );
  }, [newAll, ppAll, oldAll, preAll, sfAll, openSaleAll]);


  // new search box

  async function submitCustom(e, plate) {
    e.preventDefault();
    setIsPrefixSearch(false);
    setIsNewSearch(false);
    if (!plate) {
      setNewStyles([]);
      setOldStyles([]);
      setGetPrefixStyles([]);
      setPremiums([]);
      return errorToast("Please Enter Number");
    }
    setIsLoading(true);
    try {
      await getNewStyles(plate);
      await getOldStyles(plate);
      await getAllPrefixStyles(plate);
      await getPremiums(plate);
      await getSuffix(plate);
      await getOpenSales(plate);

      window.scrollTo(0, 750);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  const [isNewSearch, setIsNewSearch] = useState(false);
  const [isPrefixSearch, setIsPrefixSearch] = useState(false);

  const [selectedPrefixValues, setSelectedPrefixValues] = useState({
    part1: "_",
    part2: "_",
    part3: "_",
    part4: "_",
    part5: "_",
  });
  const handlePrefixChange = (e, part) => {
    setSelectedPrefixValues((prev) => ({
      ...prev,
      [part]: e.target.value,
    }));
  };

  async function subPrefix(e) {
    const plate = `${selectedPrefixValues.part1}${selectedPrefixValues.part2}${selectedPrefixValues.part3}${selectedPrefixValues.part4}${selectedPrefixValues.part5}`;
    submitCustom(e, plate.replace(/_/g, ""));
    /*
    setIsLoading(true);
    setIsPrefixSearch(true);
    setPremiums([]);
    setSuffix([]);
    setAllArray([]);
    setNewAll([]);
    setGetPrefixStyles([]);
    setNewStyles([]);
    setOldStyles([]);
    try {
      const plate = `${selectedPrefixValues.part1}${selectedPrefixValues.part2}${selectedPrefixValues.part3}${selectedPrefixValues.part4}${selectedPrefixValues.part5}`;
      setPlate(plate.replace(/_/g, ""));
      addData("search-plate", plate);
      let res = await apiRequest.get(
        `/prefix/prefix-style/custom/${plate}/${page}`
      );
      if (res.data.status === 200) {
        let result = res.data.message;

        setGetPrefixStyles(
          result.map((r) => ({
            fullNumber: r.pp_fullNumber?.replace(
              extractNumber(r.pp_fullNumber),
              `${extractNumber(r.pp_fullNumber)} `
            ),
            price: r.pp_price,
          }))
        );

        let all = result.map((r) => ({
          fullNumber: r.pp_fullNumber,
          price: r.pp_price,
          route: "view-prefix",
        }));

        setPpAll(all);
        // let number = res.data?.message?.filter(
        //   (p) =>
        //     p?.pp_fullNumber?.replace(/\s+/g, "").toLowerCase() ===
        //     plate.replace(/\s+/g, "").toLowerCase()
        // )[0];

        // setSearchNumber(
        //   searchNumber.length > 0
        //     ? searchNumber
        //     : [{ ...number, route: "view-prefix" }]
        // );
      } else {
        setNewStyles([]);
        console.log(res.data.message);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
      */
  }

  const [selectedNewStyleValues, setSelectedNewStyleValues] = useState({
    part1: "_",
    part2: "_",
    part3: "_",
    part4: "_",
    part5: "_",
    part6: "_",
  });

  const handleNewStyleChange = (e, part) => {
    setSelectedNewStyleValues((prev) => ({
      ...prev,
      [part]: e.target.value,
    }));
  };

  async function subNewStyleSearch(e) {
    const plate = `${selectedNewStyleValues.part1}${selectedNewStyleValues.part2}${selectedNewStyleValues.part3}${selectedNewStyleValues.part4}${selectedNewStyleValues.part5}${selectedNewStyleValues.part6}`;
    submitCustom(e, plate.replace(/_/g, ""));
    /*
    setIsLoading(true);
    setIsNewSearch(true);
    setPremiums([]);
    setSuffix([]);
    setAllArray([]);
    setNewAll([]);
    setGetPrefixStyles([]);
    setNewStyles([]);
    setOldStyles([]);

    try {
      const plate = `${selectedNewStyleValues.part1}${selectedNewStyleValues.part2}${selectedNewStyleValues.part3}${selectedNewStyleValues.part4}${selectedNewStyleValues.part5}${selectedNewStyleValues.part6}`;
      setPlate(plate.replace(/_/g, ""));
      addData("search-plate", plate);
      getNewStyles(plate.replace(/_/g, ""));
      let res = await apiRequest.get(
        `/plate/new-style/custom/${plate}/${page}`
      );
      if (res.data.status == 200) {
        let { message } = res.data;

        let value = message.map((p) => ({
          price: p.price,
          fullNumber: p.fullNumber?.replace(
            extractNumber(p.fullNumber),
            `${extractNumber(p.fullNumber)} `
          ),
        }));

        let valueSet = new Set(value);

        setNewStyles([...valueSet]);

        let all = res.data.message?.map((p) => ({
          price: p.price,
          fullNumber: p.fullNumber,
          route: "view",
        }));

        setNewAll(all);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
      */
  }

  // new search box ends

  return (
    <div>
      {isLoading && <Loader />}
      <div className="home-banner">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="banner-serch-bar">
                <div className="banner-serch-bar-title">
                  <h2>We Make Buying Registrations Fast & Easy...</h2>
                  {dynamicBanner && (
                    <div
                      style={{
                        fontSize: dynamicStyles.fontSize,
                        fontWeight: dynamicStyles.fontWeight,
                        marginBottom: "16px",
                      }}
                    >
                      {dynamicBanner?.content}
                    </div>
                  )}
                  {!dynamicBanner && (
                    <h3>12-48 months finance on order over £250</h3>
                  )}
                </div>

                <div className="form-tabs">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home"
                        type="button"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        Super search
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#profile"
                        type="button"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                      >
                        Prefix Search
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="contact-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#contact"
                        type="button"
                        role="tab"
                        aria-controls="contact"
                        aria-selected="false"
                      >
                        Current search
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <form onSubmit={submit}>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Enter your initials, name, car or anything else...
                      "
                            value={plate}
                            onChange={(e) => setPlate(e.target.value)}
                          />
                          <button className="btn btn-dark" type="submit">
                            Search
                          </button>
                        </div>
                      </form>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="profile"
                      role="tabpanel"
                      aria-labelledby="profile-tab"
                    >
                      <div className="selet-box-list">
                        <ul>
                          <li>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={selectedPrefixValues.part1}
                              onChange={(e) => handlePrefixChange(e, "part1")}
                            >
                              {getAlphas().map((a, i) => (
                                <option key={i} value={a == "ANY" ? "_" : a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={selectedPrefixValues.part2}
                              onChange={(e) => handlePrefixChange(e, "part2")}
                            >
                              {prefixStyleNumber?.map((n, i) => (
                                <option value={n == "ANY" ? "_" : n} key={i}>
                                  {n}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={selectedPrefixValues.part3}
                              onChange={(e) => handlePrefixChange(e, "part3")}
                            >
                              {getAlphas().map((a, i) => (
                                <option key={i} value={a == "ANY" ? "_" : a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={selectedPrefixValues.part4}
                              onChange={(e) => handlePrefixChange(e, "part4")}
                            >
                              {getAlphas().map((a, i) => (
                                <option key={i} value={a == "ANY" ? "_" : a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={selectedPrefixValues.part5}
                              onChange={(e) => handlePrefixChange(e, "part5")}
                            >
                              {getAlphas().map((a, i) => (
                                <option key={i} value={a == "ANY" ? "_" : a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </li>

                          <li>
                            <div className="form-group">
                              <button
                                className="btn btn-dark"
                                onClick={(e) => subPrefix(e)}
                              >
                                Search
                              </button>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="contact"
                      role="tabpanel"
                      aria-labelledby="contact-tab"
                    >
                      <div className="selet-box-list">
                        <ul>
                          <li>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={selectedNewStyleValues.part1}
                              onChange={(e) => handleNewStyleChange(e, "part1")}
                            >
                              {getAlphas().map((a, i) => (
                                <option key={i} value={a == "ANY" ? "_" : a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={selectedNewStyleValues.part2}
                              onChange={(e) => handleNewStyleChange(e, "part2")}
                            >
                              {getAlphas().map((a, i) => (
                                <option key={i} value={a == "ANY" ? "_" : a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={selectedNewStyleValues.part3}
                              onChange={(e) => handleNewStyleChange(e, "part3")}
                            >
                              {generateNewStyleNumber().map((a, i) => (
                                <option key={i} value={a == "ANY" ? "_" : a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={selectedNewStyleValues.part4}
                              onChange={(e) => handleNewStyleChange(e, "part4")}
                            >
                              {getAlphas().map((a, i) => (
                                <option key={i} value={a == "ANY" ? "_" : a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={selectedNewStyleValues.part5}
                              onChange={(e) => handleNewStyleChange(e, "part5")}
                            >
                              {getAlphas().map((a, i) => (
                                <option key={i} value={a == "ANY" ? "_" : a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={selectedNewStyleValues.part6}
                              onChange={(e) => handleNewStyleChange(e, "part6")}
                            >
                              {getAlphas().map((a, i) => (
                                <option key={i} value={a == "ANY" ? "_" : a}>
                                  {a}
                                </option>
                              ))}
                            </select>
                          </li>
                          <li>
                            <div className="form-group">
                              <button
                                className="btn btn-dark"
                                onClick={(e) => subNewStyleSearch(e)}
                              >
                                Search
                              </button>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {(isPrefixSearch || isNewSearch) &&
                  newStyles?.length == 0 &&
                  getPrefixStyles?.length == 0 ? (
                    <div className="mt-3">
                      <p className="text-danger pl-5">
                        No Results Found For (
                        {isNewSearch
                          ? `${selectedNewStyleValues.part1}${selectedNewStyleValues.part2}${selectedNewStyleValues.part3}${selectedNewStyleValues.part4}${selectedNewStyleValues.part5}${selectedNewStyleValues.part6}`
                          : `${selectedPrefixValues.part1}${selectedPrefixValues.part2}${selectedPrefixValues.part3}${selectedPrefixValues.part4}${selectedPrefixValues.part5}`}
                        )
                      </p>
                    </div>
                  ) : null}
                </div>

                {/* <h3>Enter your initials, name, car or anything else...</h3> */}
                {/* <div className="rating-row">
                  <img crossOrigin="anonymous" src="/img/google.png" />
                  <h2>
                    Google Rating <strong>4.8</strong>
                  </h2>
                  <ul>
                    <li>
                      <span>
                        <i className="bi bi-star-fill"></i>
                      </span>
                    </li>
                    <li>
                      <span>
                        <i className="bi bi-star-fill"></i>
                      </span>
                    </li>
                    <li>
                      <span>
                        <i className="bi bi-star-fill"></i>
                      </span>
                    </li>
                    <li>
                      <span>
                        <i className="bi bi-star-fill"></i>
                      </span>
                    </li>
                    <li>
                      <span>
                        <i className="bi bi-star-fill"></i>
                      </span>
                    </li>
                  </ul>
                  <h6>See all our reviews</h6>
                </div> */}
              </div>
            </div>
            <div className="col-md-6">
              <div className="car-img">
                {dynamicImageStatus == "active" ? (
                  <img src={dynamicImage} crossOrigin="anonymous" />
                ) : (
                  <img src="/img/number-car.png" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {searchNumber.length > 0 ? (
        <ViewNumber details={searchNumber[0]} />
      ) : null}
      {/* for new styles dark bg */}
      {newStyles.length > 0 ? (
        <>
          {!isPrefixSearch && !isNewSearch ? (
            <div className="home-content-btns">
              <a href="#prefixStyle">Prefix</a>
              <a href="#premium">Premium</a>
              <a href="#dateless">Dateless</a>
              <a href="#suffix">Suffix</a>
            </div>
          ) : null}
          <div className="dark-bgPremiumRegistrations">
            <PremiumRegistrations
              title={`NEW STYLE '${getData(
                "search-plate"
              )?.toUpperCase()}' REGISTRATIONS`}
              plates={newStyles}
              page={"new-plates"}
              plate={getData("search-plate")}
            />
          </div>
        </>
      ) : allArray.length === 0 ? (
        <FeaturedRegistrations />
      ) : null}
      {/* for prefix */}
      {getPrefixStyles.length > 0 ? (
        <div className="dark-bgPremiumRegistrations" id="prefixStyle">
          <PremiumRegistrations
            title={`PREFIX STYLE '${getData(
              "search-plate"
            )?.toUpperCase()}' REGISTRATIONS`}
            plates={getPrefixStyles}
            page={"prefix"}
            plate={getData("search-plate")}
          />
        </div>
      ) : null}
      {/* premiums */}
      {premiums.length > 0 ? (
        <div className="dark-bgPremiumRegistrations" id="premium">
          <Seller
            title={`PREMIUM ALL REGISTRATIONS`}
            plate={plate}
            plates={premiums}
          />
        </div>
      ) : null}
      {/* for old plates */}
      {oldStyles?.length > 0 ? (
        <div id="dateless">
          <PremiumRegistrations
            title={`Dateless '${getData(
              "search-plate"
            )?.toUpperCase()}' REGISTRATIONS`}
            plates={oldStyles}
            page={"old"}
            plate={getData("search-plate")}
          />
          <div className="container"></div>
        </div>
      ) : null}

      {/* suffix */}
      {premiums.length > 0 ? (
        <div className="dark-bgPremiumRegistrations" id="suffix">
          <Seller
            title={`SUFFIX '${getData(
              "search-plate"
            )?.toUpperCase()}' REGISTRATIONS`}
            plate={plate}
            plates={suffix}
          />
        </div>
      ) : null}
      {/* open sale */}
      {/* {openSales?.length > 0 ? (
        <div className="dark-bgPremiumRegistrations" id="openSale">
          <PremiumRegistrations
            title={`OPEN SALE '${getData(
              "search-plate"
            )?.toUpperCase()}' REGISTRATIONS`}
            plates={openSales}
            page={"open-sale"}
            plate={getData("search-plate")}
          />
        </div>
      ) : null} */}
    </div>
  );
}

export default Home;
